module.exports = {"links":[["Core Docs","https://vuejs.org"],["Forum","https://forum.vuejs.org"],["Community Chat","https://chat.vuejs.org"],["Twitter","https://twitter.com/vuejs"],["Docs for This Template","http://vuejs-templates.github.io/webpack/"]],"resources":[["Vue-Router","http://router.vuejs.org/"],["Vue-Loader","http://vue-loader.vuejs.org/"],["Vuex","http://vuex.vuejs.org/"]]}


//////////////////
// WEBPACK FOOTER
// ./src/assets/Hello.json
// module id = 8R4H
// module chunks = 1